import React from 'react';
import { Container } from 'react-bootstrap';

const ManageBooking = () => {
    return (
        <Container>
            <h2>Manage Order page</h2>
        </Container>
    );
};

export default ManageBooking;